import React from 'react';
import ClusterManagementPage from './ClusterManagementComponents/ClusterManagementPage';

const ClusterManagementView = (props) => {
  return <ClusterManagementPage {...props} />;
};

export default ClusterManagementView;
